import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import PageLoader from './PageLoader'

export default function ProtectedRoute({ children, role }) {
  const { isAuth, isAdmin, isClient, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return <PageLoader />
  }

  if (!isAuth) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />
  }

  if (role === 'admin' && !isAdmin) {
    return <Navigate to="/" replace />
  }

  if (role === 'client' && !isClient) {
    return <Navigate to="/" replace />
  }

  return children
}
